const level = [
  [  0,   0,   0,   0,   0,   0,   0,   0,   0,   0],
  [ 99,  99,  99,  99,  99,  99,   0,   0,   0,   0],
  [ 99,  77,  38,  51,  64,  99,  99,  99,  99,   0],
  [ 99,   0,   0,   7,  99,  99,   0,   0,  99,   0],
  [ 99,   0,   9,  10,   0,   0,   0,   0,  99,   0],
  [ 99,  52,   8,   0,  99,   0,   0,   0,  99,   0],
  [ 99,  99,   0,   0,  99,  99,  99,  99,  99,   0],
  [  0,  99,  99,  99,  99,   0,   0,   0,   0,   0],

]

export default level